import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { FailedAttempts } from './components/FailedAttempts';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { TargetAudience } from './components/TargetAudience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (!(window as any).fbq) {
      const n: any = (window as any).fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '1481399080300244');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream-50 font-body text-brown-900 selection:bg-gold-500 selection:text-white" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1481399080300244&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Problem data-id="element-5" />
        <FailedAttempts data-id="element-6" />
        <Mechanism data-id="element-7" />
        <WhatYouGet data-id="element-8" />
        <TargetAudience data-id="element-9" />
        <HowItWorks data-id="element-10" />
        <Proof data-id="element-11" />
        <FAQ data-id="element-12" />
        <Offer data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}